import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTabs } from '@shared/hooks';
import { PermissionUtils } from '@shared/utils';
import { AccountType } from '@shared/api';
import { ReportDepositTab, ReportCreditTab } from './widgets';
import { PageContainer } from '@widgets';
import { NoData, Spinner, Tabs } from '@shared/widgets';

export const ReportsPage = () => {
  const tabsState = useTabs({ withDebitCard: true });

  const { t } = useTranslation('reports');

  const currentTabView = useMemo(() => {
    if (tabsState.loading) return <Spinner />;
    if (tabsState.tab === AccountType.Payment && PermissionUtils.viewReportsPaymentsTab()) return <ReportDepositTab />;
    else if (tabsState.tab === AccountType.Card && PermissionUtils.viewReportsCardsTab()) return <ReportCreditTab />;
    else return <NoData />;
  }, [tabsState.loading, tabsState.tab]);
  return (
    <PageContainer title={t('title')} header={t('header')}>
      {!tabsState.loading && tabsState.tabs.length > 1 && <Tabs options={tabsState.tabs} value={tabsState.tab!} onChange={tabsState.onChangeTab} />}
      {currentTabView}
    </PageContainer>
  );
};
